import { render, staticRenderFns } from "./itemCenterInfo.vue?vue&type=template&id=7476687a&scoped=true"
import script from "./itemCenterInfo.vue?vue&type=script&lang=js"
export * from "./itemCenterInfo.vue?vue&type=script&lang=js"
import style0 from "./itemCenterInfo.vue?vue&type=style&index=0&id=7476687a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476687a",
  null
  
)

export default component.exports